import { render, staticRenderFns } from "./FamilyClient.vue?vue&type=template&id=54cb0bd4&scoped=true"
import script from "./FamilyClient.vue?vue&type=script&lang=js"
export * from "./FamilyClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cb0bd4",
  null
  
)

export default component.exports